import { useHistory } from 'react-router-dom';
import { Receipt, TrendingUp, LocalBar, WifiOff, FileCopy } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import PointOnSaleIcon from 'components/icons/PointOnSaleIcon';
import 'styles/pages/ReportinPage.scss';
import UserRoleType from 'types/enums/UserRoleType';
import React from 'react';
import AppContext from 'contexts/AppContext';

interface ReportingType {
  name: string;
  icon: JSX.Element;
  color: string;
  redirect: string;
  allowedRoles?: UserRoleType[];
}

const reportingTypes: ReportingType[] = [
  {
    name: 'reporting-page-consumes',
    icon: <Receipt style={{ fontSize: 48, color: '#4CAF50' }} />,
    color: '#4CAF50',
    redirect: '/private/reporting/consumptions',
  },
  {
    name: 'reporting-page-loads',
    icon: <TrendingUp style={{ fontSize: 48, color: '#2196F3' }} />,
    color: '#2196F3',
    redirect: '/private/reporting/loads',
  },
  {
    name: 'reporting-page-boxes',
    icon: <PointOnSaleIcon size={48} color="#9C27B0" />,
    color: '#9C27B0',
    redirect: '/private/reporting/cash-boxes',
  },
  {
    name: 'reporting-page-event-consumptions',
    icon: <LocalBar style={{ fontSize: 48, color: '#ec2121' }} />,
    color: '#ec2121',
    redirect: '/private/reporting/events-consumptions',
  },
  {
    name: 'reporting-page-failed-jobs',
    icon: <WifiOff style={{ fontSize: 48, color: '#964B00' }} />,
    color: '#964B00',
    redirect: '/private/reporting/failed-jobs',
  },
  {
    name: 'reporting-page-orders-to-invoice',
    icon: <FileCopy style={{ fontSize: 48, color: '#FF6600' }} />,
    color: '#FF6600',
    redirect: '/private/billing-orders',
    allowedRoles: [UserRoleType.VenueEditor, UserRoleType.CommerceEditor],
  },
];

export default (): JSX.Element => {
  const history = useHistory();
  const { t } = useTranslation();
  const { authData } = React.useContext(AppContext);
  const role = authData?.user?.role as UserRoleType;

  const filteredReportingTypes = reportingTypes.filter(
    (reportingType) => !reportingType.allowedRoles || reportingType.allowedRoles.includes(role),
  );

  return (
    <div className="reporting-container">
      {filteredReportingTypes.map((type, i) => {
        return (
          <article
            key={i}
            className="card"
            onClick={() => history.push(type.redirect)}
            style={{
              borderColor: type.color,
              backgroundColor: type.color + '10',
            }}
          >
            <div className="ctn">
              {type.icon}
              <p>{t(type.name)}</p>
            </div>
          </article>
        );
      })}
    </div>
  );
};
